import React from 'react'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'

type TabDescriptor = {
  id: string | number
  title: React.ReactNode
}

type TabsHipladeProps = {
  status_id: string | number
  handleChangeTab: (event: React.SyntheticEvent, newValue: string) => void
  tabs: TabDescriptor[]
}

// Aparência (indicador brandDark 2px, aba selecionada brandDark/600, aba
// inativa textMuted, 0.875rem, minHeight 52) vem do tema — ver
// `MuiTabs`/`MuiTab` em src/common/theme. Nada de override local aqui.
export default function TabsHiplade({
  status_id,
  handleChangeTab,
  tabs,
}: TabsHipladeProps) {
  return (
    <Tabs
      value={String(status_id)}
      onChange={handleChangeTab}
      variant="scrollable"
      scrollButtons="auto"
      allowScrollButtonsMobile
    >
      {tabs.map((tab, index) => (
        <Tab value={String(tab.id)} key={index} label={tab.title} />
      ))}
    </Tabs>
  )
}
